export const calculateLinearFeet = (weight, type) => {
  const w = Number.parseFloat(weight) || 0;
  return type ? (w * (type === 7 ? 2 : 1)) / 1000 : 0;
};

export const mergeByKeys = (arr, keysToMerge) => {
  if (!arr || arr.length === 0) return [];

  const mergedObject = {};

  for (const key of keysToMerge) {
    mergedObject[key] = [];
  }

  for (const item of arr) {
    for (const [key, value] of Object.entries(item)) {
      if (keysToMerge.includes(key)) {
        if (value) {
          const valuesToMerge = value instanceof Object ? value : [value];
          mergedObject[key].push(...valuesToMerge);
        }
      } else if (!(key in mergedObject)) {
        mergedObject[key] = value;
      }
    }
  }

  return [mergedObject];
};

export const getTrailerStatusColor = (status) => {
  const newStatus = status.trim();
  switch (newStatus) {
    // Assigned - Yellow
    case 'ASN':
      return '#ffffcc';

    // Planned/Unconfirmed - Brown
    case 'PLN':
    case 'UNCN':
      return '#B86B3C';

    // Broken/Problem - Red
    case 'BRK':
      return '#ff9999';

    // No color for these statuses
    case 'RECV':
    case 'UNAS':
      return '';
    default:
      return '';
  }
};
